<template>
    <div>
        <div class="primarylists list-mobile" v-if="!mobile">
            <div class="titles clear" id="explore">
                <img src="../../../static/images/icon-st.jpg"/>
                <div class="title l title-flex"><span style="text-transform: uppercase!important;">{{ $t("manage.lesson") }}</span>
                    <!-- <el-button @click="showBtnDownload ? download__v2() : false" :class="[{ disable: !showBtnDownload }]" class="exam_btn btn-login new-btn">{{$t('manage.download')}} &#10515;</el-button> -->
                </div>
            </div>
        </div>
        <div class="manage--main" ref="manageLeeson">
             <div class="header-manage">
                <div class="icon-img" @click="backLesson()">
                    <img src="../../../static/images/back.png" />
                </div>
                <div class="user-name">
                   {{ nameTitle }}
                </div>
                <div class="icon-img-right" @click="showUser()">
                    <template v-if="!menu"><img src="../../../static/images/khoahoccuatoi-trang.png" /></template>
                    <template v-else><img :src="$CONST.HEADER.IMG.SEARCH" /></template>
                </div>
            </div>
            <!-- left -->
            <left v-if="loadContentLeft" :data="{type: type, list: dataLeft, studentId: studentId, courseId: courseId}" v-on:changeItem="getDataContent($event)"></left>
            <!-- main -->
            <contentManage ref="contentManage" v-if="loadContent" :data="{type: type, list: dataContent, studentId: studentId, courseId: courseId, checkBackStudent: checkBackStudent, nameCourse: nameTitle, listQuestion: listQS, purchaseDetails: purchaseDetails}" v-on:showDetailStudent="showDetailStudent($event)" v-on:back="back($event)" @listQuestionsCourseManage="listQuestionsCourseManage" @listStudentsCourse="listStudentsCourse"></contentManage>
        </div>
        <loading class="loading--lesson" :showLoading="!isLoadData" />

        <!-- Loading download -->
        <loading class="loading--lesson" :showLoading="loadingLesson"/>
    </div>
</template>

<script>
import { mapState } from "vuex";
import left from "@/components/manage/left";
import contentManage from "@/components/manage/content/lessons";
import loading from "@/components/loading/loading";

export default {
    name: "manageLesson",
    data() {
        return {
            data: [],
            dataLeft: [],
            dataContent: [],
            userID: 1432,
            studentId: this.$CONST.COMMON.STRING.IS_NULL,
            courseId: this.$CONST.COMMON.STRING.IS_NULL,
            type: this.$CONST.COMMON.NUMBER.ZERO,
            filterFieldID: this.$CONST.COMMON.STRING.IS_NULL,
            curriculum: [],
            loadContent: true,
            loadContentLeft: true,
            nameTitle: "",
            checkBackStudent: false,
            menu: true,
            listQuestion: [],
            listInfoCourse: [],
            isLoadData: false,
            showBtnDownload: false,
            listQS: [],
            purchaseDetails: {},
            isCheck: true,
        };
    },
    components: {
        left,
        contentManage,
        loading
    },
    async created () {
        this.userID = this.$attrs.userId || window.sessionStorage.getItem("id");
        this.data = await this.getAllList();
        this.isLoadData = true;
        // ======
        if(this.data.length>0){
            let listTeacher = [];
            this.data.forEach(value => {
                if(value.teacherList != null){
                    value.teacherList.forEach(item => {
                        if(item.id==window.sessionStorage.getItem("id")){
                            listTeacher.push(item);
                        }
                    });
                }
            });
            this.init();
        } else {
            this.$confirm(window.vm.$i18n.t("new.title93"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
            .then(() => {
                window.history.go(-1);
            })
            .catch(() => {
                this.$router.push("/home");
            });
        }
    },
    watch: {
        filterFieldID(value) {
            this.loadContentLeft = false;
            this.$nextTick(() => {
              this.loadContentLeft = true;
            });
        }
    },
    computed: {
        // Lấy dữ liệu từ store
        ...mapState({
            mobile: (state) => state.header.mobile,
            loadingLesson: (state) => state.manageStudent.loadingLesson
        }),
    },
    methods: {
        listQuestionsCourseManage(data){
            this.dataLeft.forEach(value => {
                if (value.courseId==data.courseId) {
                    value.questionList = data.listQuestions;
                }
            });
        },
        listStudentsCourse(data){
            this.dataLeft.forEach(value => {
                if (value.courseId==data.courseId) {
                    value.studentList = data.list;
                }
            });
        },
        download__v2: function () {
            let listDataIsTeacher = [];
            this.data.forEach(val => {
                if(val.isTeacher) listDataIsTeacher.push(val)
            })
            let tempList = [];
            listDataIsTeacher.forEach(x => {
                let itemListData = {};
                if(x.studentList) {
                    x.totalStudentsCourse = x.studentList.length;
                    let listTeacher = []
                    x.teacherList.forEach(z => {
                        listTeacher.push(z.userName);
                    })
                    x.teachers = listTeacher.join();
                    x.teachers = x.teachers.split(',').join("|");
                    let listStatus1 = [];
                    let listStatus2 = [];
                    let listStatus3 = [];
                    x.studentList.forEach(y => {
                        if(y.startStudyDate != null && y.endStudyDate != null){
                            listStatus3.push(y);
                        } else if(y.startStudyDate == null && y.endStudyDate == null){
                            listStatus1.push(y);
                        } else {
                            listStatus2.push(y);
                        }
                    })
                    x.status1 = listStatus1.length;
                    x.status2 = listStatus2.length;
                    x.status3 = listStatus3.length;
                }else {
                    x.totalStudentsCourse = 0;
                    x.status1 = 0;
                    x.status1 = 0;
                    x.status3 = 0; 
                }
                this.data.forEach(info => {
                    if(x.courseId == info.courseId) {
                        x.startCourseDate = info.purchaseDetails.startDate;
                        x.endCourseDate = info.purchaseDetails.endDate;
                    }
                })
                itemListData.startCourseDate = x.startCourseDate;
                itemListData.courseId = x.courseId;
                itemListData.courseName = x.courseName;
                itemListData.endCourseDate = x.endCourseDate;
                itemListData.studing = x.status2;
                itemListData.notStudy = x.status1;
                itemListData.studied = x.status3;
                itemListData.teachers = x.teachers;
                itemListData.totalStudentsCourse = x.totalStudentsCourse;
                itemListData.studentList = x.studentList;
                tempList.push(itemListData);
            })
            const data = tempList.reduce((a, v) => {
                if(v.studentList) {
                    const students = v.studentList.reduce((s, sv) => {                    
                        v.startCourseDate ? sv.startCourseDate = v.startCourseDate : sv.startCourseDate = '';
                        sv.courseId = v.courseId;
                        sv.courseName = v.courseName;
                        v.endCourseDate? sv.endCourseDate = v.endCourseDate : sv.endCourseDate = '';
                        sv.studing = v.studing;
                        sv.notStudy = v.notStudy;
                        sv.studied = v.studied;
                        sv.teachers = v.teachers;
                        sv.totalStudentsCourse = v.totalStudentsCourse;
                        let status = "";
                        if (sv.status == 1) {
                            status = this.$t("statictical.studying");
                        } else if (sv.status == 2) {
                            status = this.$t("statictical.completed");
                        } else {
                            status = this.$t("statictical.unstudied");
                        }
                        sv.textStatus = status;
                        s.push(sv);
                        return s;
                    }, []);
                    v.students = students;
                    a.push(v);
                }
                return a;
            }, []);

            const result = data.reduce((a, v) => {
                a = a.concat(v.students);
                return a;
            }, []);
            var headerName = [
                {
                    key: "courseName",
                    value: "home.courseName"
                },
                {
                    key: "startCourseDate",
                    value: "new.title60"
                },
                {
                    key: "endCourseDate",
                    value: "new.title61"
                },
                {
                    key: "teachers",
                    value: "manage_lesson.teacher_charge"
                },
                {
                    key: "totalStudentsCourse",
                    value: "manage_lesson.total_student"
                },
                {
                    key: "notStudy",
                    value: "manage_lesson.status1"
                },
                {
                    key: "studing",
                    value: "manage_lesson.status2"
                },
                {
                    key: "studied",
                    value: "manage_lesson.status3"
                },
                {
                    key: "userName",
                    value: "new.title51"
                },
                {
                    key: "textStatus",
                    value: "home.status"
                },
            ]
            var params = {
                header: true,
                titles: ["courseName", "startCourseDate", "endCourseDate", "teachers", "totalStudentsCourse", "notStudy", "studing", "studied", "userName", "textStatus"],
                data: result,
                headerName: headerName
            }
            this.exportCsv(params);
        },
        checkListStatusStudy: function(data){
        let listStatus1 = [];
        let listStatus2 = [];
        let listStatus3 = [];
        data.forEach(value => {
            if(value.startStudyDate!=null&&value.endStudyDate!=null){
                listStatus3.push(value);
            } else if(value.startStudyDate==null&&value.endStudyDate==null){
                listStatus1.push(value);
            } else {
                listStatus2.push(value);
            }
        });
        this.status1 = listStatus1.length;
        this.status2 = listStatus2.length;
        this.status3 = listStatus3.length;
      },
        init: function () {
            this.dataLeft = this.getData({id: this.userID, type: this.type});
            this.courseId = this.checkIdCourse();
            // this.courseId = this.dataLeft[this.$CONST.COMMON.NUMBER.ZERO].courseId;
            this.getDataContent({id: this.courseId, type: this.type});
            if (this.mobile) this.showUser();
        },
        showUser: function () {
            this.menu = !this.menu;
            document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
        },
        checkIdCourse(){
            let idCourseOK = null;
            let arrCheck  = [];
            let arrListIdCourse = [];
            this.data.forEach(async (value) => {
                arrListIdCourse.push(value.courseId);
                if(value.isTeacher){
                    arrCheck.push(value.courseId);
                }
            });
            if(arrCheck.length>0){
                idCourseOK = arrCheck[0];
            } 
            else {
                this.$router.push("/home")
            }
            return idCourseOK;
        },
        getAllList: function () {
            return new Promise((resolve, reject) => {
                this.$api
                .post("/courseStudy/getAllCoursesByStudent", {})
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err.response);
                });
            });
        },
        getData: function (params) {
            let result = [];
            this.data.forEach(item => {
                if (params.type == this.$CONST.COMMON.NUMBER.ZERO) {
                    item["isTeacher"] = false;
                    if (item.teacherList != null && item.teacherList.length >= 0) {
                        let key = item.teacherList.findIndex((teacher) => teacher.id == this.userID);
                        if (key >= 0) {
                            item.isTeacher = true;
                        }
                        result.push(item);
                    } else {
                        result.push(item);
                    }
                } else {
                    if (item.courseId == this.courseId) {
                        result = item.studentList;
                    }
                }
            });
            return result;
        },
        getDataContent: function (params) {
            this.dataContent = {};
            this.menu = params.change ? params.change : this.menu;
            this.filterFieldID = params.type == this.$CONST.COMMON.NUMBER.ZERO ? 'courseId' : 'id';
            if (params.type == this.$CONST.COMMON.NUMBER.ZERO) {
                this.dataLeft.forEach(item => {
                    if (item[this.filterFieldID] == params.id) {
                        this.listQS = item.questionList;
                        this.purchaseDetails = item;
                        this.dataContent = item.studentList;
                        this.courseId = params.id;
                        this.studentId = this.$CONST.COMMON.STRING.IS_NULL;
                        this.curriculum = item.curriculum;
                        if(params.checkBack==true){
                            this.checkBackStudent = true;
                        } else {
                            this.checkBackStudent = false;
                        }
                    }
                }); 
            } else {
                this.studentId = params.id;
                this.curriculum = [];
                if(params.checkBack==true){
                    this.checkBackStudent = true;
                } else {
                    this.checkBackStudent = false;
                }
            }
            this.loadContent = false;
            this.$nextTick(() => {
              this.loadContent = true;
            });
            if (this.isCheck) {
                this.isCheck = false;
                this.$nextTick(() => {
                    this.loadContentLeft = true;
                });
            }
            ///// get name couser in data
            this.data.forEach(element => {
                if(element.courseId==params.id) {
                    this.nameTitle = element.courseName;
                }
            });
        },
        showDetailStudent: function (params) {
            this.type = params.type;
            this.dataLeft = this.getData(params);
            this.getDataContent(params);
        },
        back: function (params) {
            this.type = params.type;
            this.dataLeft = this.getData({id: this.userID, type: params.type});
            this.getDataContent({id: params.courseId, type: params.type, checkBack: true});
        },
        backLesson(){
            this.$router.push("/home");
        },
    }
};
</script>
<style scoped>
.exam_btn.btn-login.disable {
    background: #d2d2d2 !important;
    cursor: no-drop;
}
.primarylists {
    margin-top: 15px !important;
    margin: 0 auto;
    max-width: 1200px;
    width: 100%;
}
.title-flex{display:flex;align-items: center;}
.new-btn{margin:0 0px 0 10px!important}
.user-name{text-transform: none!important;}
</style>



// WEBPACK FOOTER //
// src/views/manage/lessons.vue